import { EventBus } from '@/main'
import Sortable from 'sortablejs'
import SortableConfig from './config'
import SortableFunctions from './sortableFunctions'

export default {
  // CHECKLIST
  checklist: {
    create: function (listing, handler) {
      const element = Sortable.create(listing, {
        // group: 'draggable-listing',
        ...this.config,
        handle: handler,
        onEnd: function (event) {
          const draggedInfo = SortableFunctions.getElementNewOrder(event, 'checklist')
          if (event.oldIndex === event.newIndex) return
          EventBus.$emit('checklist-dragged', draggedInfo)
        },
      })
      return element
    },
    destroy: function (element) {
      if (!element) return
      return element.destroy()
    },
    config: {
      ...SortableConfig,
    },
  },
  // CHECKLIST ITEM
  checklistItem: {
    create: function (listing, handler) {
      const element = Sortable.create(listing, {
        // group: 'item-listing',
        ...this.config,
        handle: handler,
        onEnd: function (event) {
          const draggedInfo = SortableFunctions.getElementNewOrder(event, 'item')
          if (event.oldIndex === event.newIndex) return
          EventBus.$emit('item-dragged', draggedInfo)
        },
      })
      return element
    },
    destroy: function (element) {
      if (!element) return
      return element.destroy()
    },
    config: {
      ...SortableConfig,
    },
  },
}
